export default __webpack_public_path__ + "locales/nl/Profile.json?hash=4b205f19b0195168e31a5beed33a26b5";